import React, { useState } from 'react';
import { X, Plus, CheckCircle, Circle, Flag } from 'lucide-react';
import { ParkingLotItem } from '../types';
interface ParkingLotProps {
  isOpen: boolean;
  onClose: () => void;
  items: ParkingLotItem[];
  onAddItem: (question: string) => void;
  onToggleResolve: (id: string) => void;
  onToggleReturn: (id: string) => void;
}
export function ParkingLot({
  isOpen,
  onClose,
  items,
  onAddItem,
  onToggleResolve,
  onToggleReturn
}: ParkingLotProps) {
  const [newItemText, setNewItemText] = useState('');
  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();
    if (newItemText.trim()) {
      onAddItem(newItemText.trim());
      setNewItemText('');
    }
  };
  return <div className={`fixed top-0 right-0 h-full w-96 bg-white shadow-2xl border-l border-gray-100 transform transition-transform duration-300 ease-in-out z-50 flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-51">
      <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-52">
        <div data-id="element-53">
          <h2 className="text-lg font-semibold text-sierra-dark" data-id="element-54">
            Parking Lot
          </h2>
          <p className="text-sm text-sierra-gray" data-id="element-55">
            Capture questions for later
          </p>
        </div>
        <button onClick={onClose} className="p-2 hover:bg-gray-50 rounded-full transition-colors" data-id="element-56">
          <X className="w-5 h-5 text-gray-400" data-id="element-57" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-58">
        {items.length === 0 ? <div className="text-center text-gray-400 mt-10 text-sm" data-id="element-59">
            No parked questions yet.
          </div> : items.map(item => <div key={item.id} className={`p-4 rounded-xl border ${item.isResolved ? 'bg-gray-50 border-gray-100 opacity-60' : 'bg-white border-gray-200 sierra-shadow'}`} data-id="element-60">
              <p className={`text-sm mb-3 ${item.isResolved ? 'line-through text-gray-500' : 'text-sierra-dark'}`} data-id="element-61">
                {item.question}
              </p>
              <div className="flex items-center gap-4" data-id="element-62">
                <button onClick={() => onToggleResolve(item.id)} className="flex items-center gap-1.5 text-xs font-medium text-gray-500 hover:text-sierra-dark transition-colors" data-id="element-63">
                  {item.isResolved ? <CheckCircle className="w-4 h-4 text-green-500" data-id="element-64" /> : <Circle className="w-4 h-4" data-id="element-65" />}
                  Resolve
                </button>
                <button onClick={() => onToggleReturn(item.id)} className={`flex items-center gap-1.5 text-xs font-medium transition-colors ${item.returnToThis ? 'text-amber-600' : 'text-gray-500 hover:text-sierra-dark'}`} data-id="element-66">
                  <Flag className={`w-4 h-4 ${item.returnToThis ? 'fill-current' : ''}`} data-id="element-67" />
                  Return to this
                </button>
              </div>
            </div>)}
      </div>

      <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-68">
        <form onSubmit={handleAdd} className="relative" data-id="element-69">
          <input type="text" value={newItemText} onChange={e => setNewItemText(e.target.value)} placeholder="Type a question..." className="w-full pl-4 pr-10 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-sierra-blue focus:border-transparent text-sm" data-id="element-70" />
          <button type="submit" disabled={!newItemText.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 bg-sierra-blue text-white rounded-lg disabled:opacity-50 hover:bg-green-800 transition-colors" data-id="element-71">
            <Plus className="w-4 h-4" data-id="element-72" />
          </button>
        </form>
      </div>
    </div>;
}